<!--<div id="desktop">-->
<div class="container" style="border:1px solid #bebaba">
  <div class="row indentContent">
    <div class="col-md-12">
      <div class="red" id="FontTwo">Indirect Purchaser States</div>
      <p><b>The following states are eligible for monetary benefits:</b></p>
      <div class="col-md-12 mt-3">
        <a class="red" data-toggle="collapse" href="#collapse2" role="button" aria-expanded="false" aria-controls="collapse2">
          ROUND 2 SETTLEMENTS
        </a>
        <div class="mt-3">
          <div class="collapse" id="collapse2">
            <div class="card card-body">
              Arizona<br />
              California<br />
              District of Columbia<br />
              Florida<br />
              Hawaii<br />
              Illinois<br />
              Iowa<br />
              Kansas<br />
              Maine<br />
              Massachusetts<br />
              Michigan<br />
              Minnesota<br />
              Mississippi<br />
              Missouri<br />
              Montana<br />
              Nebraska<br />
              Nevada<br />
              New Hampshire<br />
              New Mexico<br />
              New York<br />
              North Carolina<br />
              North Dakota<br />
              Oregon<br />
              Rhode Island<br />
              South Carolina<br />
              South Dakota<br />
              Tennessee<br />
              Utah<br />
              Vermont<br />
              West Virginia<br />
              Wisconsin<br />
            </div>
          </div>
        </div>
        <br />
        <a class="red mt-4" data-toggle="collapse" href="#collapse1" role="button" aria-expanded="false" aria-controls="collapse1">
          ROUND 1 SETTLEMENTS
        </a>
        <div class="mt-3">
          <div class="collapse" id="collapse1">
            <div class="card card-body">
              Arizona<br />
              California<br />
              Connecticut * <br />
              District of Columbia<br />
              Florida<br />
              Hawaii<br />
              Illinois<br />
              Iowa<br />
              Kansas<br />
              Maine<br />
              Massachusetts<br />
              Michigan<br />
              Minnesota<br />
              Mississippi<br />
              Missouri<br />
              Montana<br />
              Nebraska<br />
              Nevada<br />
              New Hampshire<br />
              New Mexico<br />
              New York<br />
              North Carolina<br />
              North Dakota<br />
              Oregon<br />
              Rhode Island<br />
              South Carolina<br />
              South Dakota<br />
              Tennessee<br />
              Utah<br />
              Vermont<br />
              West Virginia<br />
              Wisconsin<br /><br />
              <span style="color:red"> * The definition of “Indirect Purchaser States” includes Connecticut only with respect to the Amick settlement.</span>
            </div>
          </div>
        </div>
      </div><br />
    </div>





    <!--Arizona<br />
    California<br />
    Connecticut<span style="color:red"> * </span><br />
    District of Columbia<br />
    Florida<br />
    Hawaii<br />
    Illinois<br />
    Iowa<br />
    Kansas<br />
    Maine<br />
    Massachusetts<br />
    Michigan<br />
    Minnesota<br />
    Mississippi<br />
    Missouri<br />
    Montana<br />
    Nebraska<br />
    Nevada<br />
    New Hampshire<br />
    New Mexico<br />
    New York<br />
    North Carolina<br />
    North Dakota<br />
    Oregon<br />
    Rhode Island<br />
    South Carolina<br />
    South Dakota<br />
    Tennessee<br />
    Utah<br />
    Vermont<br />
    West Virginia<br />
    Wisconsin<br /><br />-->
    <!--<span style="color:red"> * The definition of “Indirect Purchaser States” includes Connecticut only with respect to the Amick settlement.</span>-->

  </div>
</div>
<br />
<br />
<!--</div>-->
<!--<app-footer></app-footer>-->
<!--</div>-->
<!--<div id="mobile">
  <div class="container" style="border:1px solid #bebaba">
    <div class="row indentContent">
      <div class="col-md-12">
        <div class="red" id="FontTwoMobile">Indirect Purchaser States</div>
        <p><b>The following states are eligible for monetary benefits:</b></p>
        Arizona<br />
        California<br />
        Connecticut<span style="color:red"> * </span><br />
        District of Columbia<br />
        Florida<br />
        Hawaii<br />
        Illinois<br />
        Iowa<br />
        Kansas<br />
        Maine<br />
        Massachusetts<br />
        Michigan<br />
        Minnesota<br />
        Mississippi<br />
        Missouri<br />
        Montana<br />
        Nebraska<br />
        Nevada<br />
        New Hampshire<br />
        New Mexico<br />
        New York<br />
        North Carolina<br />
        North Dakota<br />
        Oregon<br />
        Rhode Island<br />
        South Carolina<br />
        South Dakota<br />
        Tennessee<br />
        Utah<br />
        Vermont<br />
        West Virginia<br />
        Wisconsin<br /><br />
        <span style="color:red"> * The definition of “Indirect Purchaser States” includes Connecticut only with respect to the Amick settlement.</span>

      </div>
    </div>
    <br />
    <br />
  </div>
  <app-footer></app-footer>
</div>-->
